import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let DropDownButtonItemsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-dropdownbuttonitems';
        }
    }
});
export const DropDownButtonItemsPlugin = {
    name: 'e-dropdownbuttonitems',
    install(Vue) {
        Vue.component(DropDownButtonItemsPlugin.name, DropDownButtonItemsDirective);
    }
};
export let DropDownButtonItemDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-dropdownbuttonitem';
        }
    }
});
export const DropDownButtonItemPlugin = {
    name: 'e-dropdownbuttonitem',
    install(Vue) {
        Vue.component(DropDownButtonItemPlugin.name, DropDownButtonItemDirective);
    }
};
